var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","min-height":"400px","height":"100%","border":"none"},attrs:{"type":"text/html","src":"https://www.vrtify.com/#/channel/p/3272?iframe=true","allowfullscreen":""}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d81f901","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vrtify/Vrtify.vue
// module id = 1157
// module chunks = 4